<template>
  <!-- OUTIL DE RECHERCHE -->
  <div id="applicationSearcherInputTablet" :class="inputGroupClass" :style="sizingStyle">
    <input
      ref="input"
      type="search"
      name="recherche"
      class="form-control"
      :placeholder="searcherText"
      :title="searcherText"
      v-model="value"
      @keypress.enter.exact="search"
    />
    <button
      ref="button"
      class="btn btn-outline-light btn-small border px-1_2"
      type="submit"
      aria-label="Lancer la recherche"
      title="Lancer&nbsp;la&nbsp;recherche"
      @click="search"
    >
      <IneaIcone
        ref="icon"
        name="dgfipicon-rechercher"
        :color="searcherIconColor"
        background="transparent"
        size="xs"
        role="button"
        aria-expanded="false"
      />
    </button>
  </div>
</template>

<script>
import IneaIcone from "@clir/IneaIcone/IneaIcone";

export default {
  name: "SearchInput",
  data() {
    return { value: "", top:0 };
  },
  props: {
    config: { type: Object, default: () => {} },
    callButton: { type: Object, default: () => {} }
  },
  computed: {
    inputGroupClass() {
      return `input-group input-group-${this.searcherInputColor} ${
        this.searcherClass
      } searchimputgroup ms-1_4 me-0`;
    },
    buttonClass() {
      return this.prefixStringKey(this.config, "buttonClass", {
        prefix: "btn btn-auth text-xs fw-bold "
      });
    },
    iconColor() {
      return this.getKey(this.config, "iconColor", "");
    },
    searcherText() {
      return this.getKey(this.config, "searcherText", "");
    },
    searcherClass() {
      return this.getKey(this.config, "searcherClass", "");
    },
    searcherIconColor() {
      return this.getKey(this.config, "searcherIconColor", "");
    },
    searcherInputColor() {
      return this.getKey(this.config, "searcherInputColor", "");
    },
    sizingStyle() {
      return `top:${this.top}px !important;`;
    }
  },
  methods: {
    search() {
      this.$emit("search", this.value);
    }
  },
  components: { IneaIcone }
};
</script>
<style scoped>
#applicationSearcherInput {
  position: absolute;
  padding: 0 0.25rem 0 0;
  margin: 0.375rem 0 0 0;
  z-index: 100;
  display: flex;
  left:0;
}
</style>